import { observable, computed, set } from 'mobx';
import { INavigationFilter, IBreadcrumbFilter } from '../../interfaces/ISearchInterfaces';

export class SearchFiltersCatalog {
    @observable public navigationFilters: INavigationFilter[] = [];
    @observable public breadcrumbsFilters: IBreadcrumbFilter[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static fromJSON(data: any) {
        const searchCatalog = new SearchFiltersCatalog();
        set(searchCatalog, data);

        return searchCatalog;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public update = (data: any) => {
        set(this, data);
        this.navigationFilters = data.navigationFilters;
        this.breadcrumbsFilters = data.breadcrumbsFilters;
    };

    public getFiltersByDimensionName(uniqueDimensionName: string) {
        return this.breadcrumbsFilters.filter(
            filter => filter.dimensionName === uniqueDimensionName
        );
    }

    @computed
    public get uniqueDimensionName() {
        return [...new Set(this.breadcrumbsFilters.map(item => item.dimensionName))];
    }
}
